import styles from "./AutoGrowInput.module.css";


import {
  InputHTMLAttributes,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

interface AutoGrowInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "style"> {
  minPercent?: number;
  maxPercent?: number;
  label?:string,
}

export default function AutoGrowInput({
  minPercent = 40,
  maxPercent = 100,
  value = "",
  onChange,
  ...props
}: AutoGrowInputProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const measureRef = useRef<HTMLSpanElement | null>(null);
  const noteSpanRef = useRef<HTMLSpanElement | null>(null);
  const [width, setWidth] = useState<string>(`${minPercent}%`);

  useLayoutEffect(() => {
    const input = inputRef.current;
    const span = measureRef.current;
    const noteSpan = noteSpanRef.current;
    if (!input || !span) return;

    const parent = input.parentElement;
    if (!parent) return;

    const parentWidth = parent.clientWidth;

    span.textContent =
      typeof value === "string" && value.length > 0
        ? value
        : input.placeholder ?? "";

    const textWidth = span.offsetWidth + 20;
    const minWidth = (parentWidth * minPercent) / 100;
    const maxWidth = (parentWidth * maxPercent) / 100;

    const nextWidth = Math.min(
      Math.max(textWidth, minWidth),
      maxWidth
    );

    setWidth(`${nextWidth}px`);

    // Align noteSpan left to input
    if (noteSpan && input) {
      noteSpan.style.left = `${input.offsetLeft}px`;
    }
  }, [value, minPercent, maxPercent]);

  return (
    <>
      {props.label && (
        <label
          htmlFor={props.name || "auto-grow-input"}
          style={{ marginTop: props.title ? "-15px" : undefined }}
          title={props.title} >
          {props.title && (
            <span className={styles.noteSpan} ref={noteSpanRef}>
              {props.title}
            </span>
          )}
          {props.label}:
        </label>
      )}
      <input
        ref={inputRef}
        id={props.name || "auto-grow-input"}
        value={value}
        onChange={onChange}
        style={{ width }}
        {...props}
      />
      <span
        ref={measureRef}
        aria-hidden
        style={{
          position: "absolute",
          visibility: "hidden",
          whiteSpace: "pre",
          font: "inherit",
          padding: "0 10px",
        }}
      />
    </>
  );
}